import { STT_LANGUAGES } from "./LanguageSelector.tsx";

interface Props {
  value: string;
  onChange: (code: string) => void;
}

export function SpokenLanguageSelector({ value, onChange }: Props) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Spoken language"
      className="bg-white/10 hover:bg-white/15 text-white rounded-full px-4 py-2 outline-none focus:ring-2 focus:ring-white/40"
    >
      {STT_LANGUAGES.map((lang) => (
        <option key={lang.code} value={lang.code} className="text-canvas">
          {lang.flag} {lang.label}
        </option>
      ))}
    </select>
  );
}
